import { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import {
  Col, Row, Typography,
  Layout, Card
} from "antd";
import { useNavigate, useParams, useLocation } from "react-router";
import { LESSON } from "../../config/constants/api";
import { Get } from "../../config/api/get";
import swal from "sweetalert";
import "react-alice-carousel/lib/alice-carousel.css";
//icons
import PaymentComp from "../../components/Payment";
import { FaArrowLeft } from "react-icons/fa";
//icons





function Payment() {
  // const { id } = useParams();
  const navigate = useNavigate();
  // const dispatch = useDispatch();
  // const [lesson, setLesson] = useState({});
  // const [loading, setLoading] = useState(true);
  // const user = useSelector((state) => state.user.userData);
  // const token = useSelector((state) => state.user.userToken);
  const {state} = useLocation();


  // useEffect(() => {
  //   getLessonDetails();
  // }, []);


  // console.log("LLLL",state)


  // const getLessonDetails = async () => {
  //   try {
  //     const response = await Get(LESSON.getLessonById + id, token);

  //     console.log("response", response);
  //     if (response?.status) {
  //       setLesson(response?.data?.lesson);
  //     } else {
  //       swal("Error", response?.data?.message, "error");
  //     }
  //     setLoading(false);
  //   } catch (error) {
  //     console.log(error.message);
  //     setLoading(false);
  //   }
  // };
 useEffect(() => { window.scrollTo(0, 0); }, []);
  return (
    <Layout style={{ minHeight: "100vh" }}>
      <Row
        className="blueBackground"
        style={{
          height: "45vh",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <Typography.Title
          className="fontFamily1"
          style={{ fontSize: "30px", color: "#333d47" }}
        >
          {<> Card Details</>}
        </Typography.Title>
      </Row>

      {/* section 2 */}
      <Row
        className="whiteBackground"
        style={{ backgroundColor: "white", justifyContent: "center" }}
      >
        <Col xs={24} md={16}>
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              flexDirection: "column",

              padding: "50px 20px",
            }}
          >
            <div style={{ marginBottom: 20, marginLeft: 10 }}>
              <FaArrowLeft
                style={{ marginRight: 8, fontSize: "20px", cursor: "pointer" }}
                onClick={() => navigate(-1)}
              />
            </div>
            <Card
              className="infoBox"
              bordered={false}
              style={{
                width: "100%",
                padding: "20px",
              }}
            >
         
         <PaymentComp type={state.type} data={state?.data}/>              
            </Card>
          </div>
        </Col>
      </Row>
    </Layout>
  );
}

export default Payment;